import ArrowBackIosIcon from "@material-ui/icons/ArrowBackIos";
import React from "react";
import ListItem from "@material-ui/core/ListItem";
import clsx from "clsx";
import ListItemText from "@material-ui/core/ListItemText";
import List from "@material-ui/core/List";
import {makeStyles} from "@material-ui/core";
import {grey} from "@material-ui/core/colors";

const useOrgUnitItemStyles = makeStyles(theme => ({
    firstFolder: {
        position: 'relative',
    },
    childFolder: {
        color: grey[800],
        paddingLeft: '40px'
    },
    siblingFolder: {
        color: 'white',
        backgroundColor: grey[500],
        '&:hover': {
            color: grey[50],
            backgroundColor: grey[800],
        }
    },
    listPadding: {
        padding: '0',
        paddingTop: '1px'
    },
    hasBackButton: {
        paddingLeft: '40px'
    },
    backIcon: {
        position: 'absolute',
        top: 0,
        left: 0,
        bottom: 0,
        width: '50px',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
    }
}));

export const FoldersBrowserItem = (props: any) => {
    const classes = useOrgUnitItemStyles();
    const {organizationId, folder, isDisplayedAsChild} = props;
    const isDisplayedAsSibling = !folder.isSelected && !isDisplayedAsChild;
    const raiseSelectedFolderIdChanged = props.onFolderIdChanged;
    const children = folder.children ?
               folder.children.map((child: any) => <FoldersBrowserItem
            key={`organization-unit-list-item-${child.id}`}
            organizationId={organizationId}
            folder={child}
            isDisplayedAsChild={true}
            onFolderIdChanged={raiseSelectedFolderIdChanged}
        />
        )
        : null;

    const handleGoBackToParent = (event: any) => {
        if (event) {
            event.preventDefault();
            event.stopPropagation();
        }
        return raiseSelectedFolderIdChanged(folder.parentFolderId);
    };

    const goToParentButton = !folder.isTop && !isDisplayedAsChild && folder.parentFolderId ?
               <div className={classes.backIcon}
             onClick={handleGoBackToParent}>
                        <ArrowBackIosIcon/>
        </div>
        : null;

    return (
               <React.Fragment>
                        <ListItem button
                      key={`orgUnit-${folder.id}-button`}
                      onClick={() => raiseSelectedFolderIdChanged(folder.id)}
                      className={clsx(!folder.isTop && !isDisplayedAsChild && folder.parentFolderId && classes.hasBackButton,
                          folder.isSelected && classes.firstFolder,
                          isDisplayedAsSibling && classes.siblingFolder,
                          isDisplayedAsChild && classes.childFolder)}>
                {goToParentButton}
                                <ListItemText
                    primary={`${folder.name}`}
                />
            </ListItem>
                        <List classes={{padding: clsx(classes.listPadding)}}>
                {children}
            </List>
        </React.Fragment>);
};
